import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
    apiKey: "AIzaSyC2NmyuY0xjuwoAILUgq5FaJYAH4_Q6I8o",
    authDomain: "stockanalysis-e7963.firebaseapp.com",
    projectId: "stockanalysis-e7963",
    storageBucket: "stockanalysis-e7963.firebasestorage.app",
    messagingSenderId: "76334570581",
    appId: "1:76334570581:web:6f69886fc17b5f9154c8dc",
    measurementId: "G-JZK3NVJEGP"
  };
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);